import { createIcon } from '@chakra-ui/react';

export const SocialFacebook = createIcon({
  displayName: `SocialFacebook`,
  viewBox: `0 0 19.5 33`,
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3px"
      d="M27 3h-4.5a7.5 7.5 0 0 0-7.5 7.5V15h-4.5v6H15v12h6V21h4.5l1.5-6h-6v-4.5A1.5 1.5 0 0 1 22.5 9H27z"
      transform="translate(-9 -1.5)"
    />
  ),
});
